import Vue from "vue";

export async function createRequestedDocumentType(
  lead_type_id,
  lead_subtype,
  name
) {
  const response = await Vue.prototype.$http.post(
    `/config/requested_documents_types`,
    { name, lead_type_id, lead_subtype }
  );
  return response.data;
}

export async function listRequestedDocumentTypes(lead_type_id, lead_subtype) {
  const response = await Vue.prototype.$http.get(
    `/config/requested_documents_types/lead_type/${lead_type_id}/lead_subtype/${lead_subtype}`
  );
  return response.data;
}

export async function updateRequestedDocumentType(id, name) {
  const response = await Vue.prototype.$http.put(
    `/config/requested_documents_types/${id}`,
    { name }
  );
  return response.data;
}

export async function deleteRequestedDocumentType(id) {
  const response = await Vue.prototype.$http.delete(
    `/config/requested_documents_types/${id}`
  );
  return response.data;
}
